@let titleValue = title();

<div class="flex flex-row gap-1 justify-between items-center py-3">
  <p class="font-medium text-xl">
    @if (!isTemplateRef(titleValue)) {
      {{ titleValue }}
    } @else {
      <ng-container [ngTemplateOutlet]="titleValue"/>
    }
  </p>
  <div class="-mr-4 -mt-2">
    <ng-container [ngTemplateOutlet]="closeButton()"/>
  </div>
</div>

<div class="flex flex-col gap-4 text-surface-600" [class.mb-6]="!noBottomMargin()" [class.mb-0]="noBottomMargin()">
    <ng-content/>
</div>
